import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Some air particles are colored and the equation above illustrates that a pressure difference between the two sides leads to an acceleration and thus a displacement of the particles. The orange polar rectangle is fixed and the above it equation illustrates that an amount of air entering this volume causes an increase in mass and therefore an increase in density as the volume is fixed.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/01/10/principle/principle.m4v`,
              loop: true,
              autoplay: true,
            },
          },
          styles: {
            padding: "0 10%",
          },
        },
      },
    },
  },
};

export default principle;
